import { gql } from '@apollo/client';

export const SubscribeToAddOnsFormData = gql`
  fragment SubscribeToAddOnsFormData on Entitlement {
    offering {
      availableAddOns {
        offeringId
        name
      }
    }
  }
`;
